import { encodeSvg } from './svg';

const makeErrorIconSvg = (
  color: string
) => `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.99609 12C1.99609 6.48 6.47609 2 11.9961 2C17.5161 2 21.9961 6.48 21.9961 12C21.9961 17.52 17.5161 22 11.9961 22C6.47609 22 1.99609 17.52 1.99609 12ZM10.9961 7V13H12.9961V7H10.9961ZM10.9961 15V17H12.9961V15H10.9961Z" fill="${color}"/>
</svg>
`;

export const errorIcon = encodeSvg(makeErrorIconSvg('#AD0322'));
